import { useCallback, useState } from 'react';
import {
  ChatTaskContextType,
  IndexedInteractionStepResponse,
  MultiTurnInteractionConfiguration,
} from '@scale/shared/types/chat';
import apiFetch from 'react-scale/lib/api-fetch';

type AtLeast<T, K extends keyof T> = Partial<T> & Pick<T, K>;

type UseChatShareOptions = {
  config: MultiTurnInteractionConfiguration;
  responses: IndexedInteractionStepResponse[];
  context: AtLeast<ChatTaskContextType, 'projectId' | 'directions'> & { reviewLevel?: any }; // TODO: @Lajos use the ChatTaskContextType here!
  taskId?: string;
  projectId?: string;
};

export const useChatShare = ({
  config,
  responses,
  context,
  taskId,
  projectId,
}: UseChatShareOptions) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [slug, setSlug] = useState<string>('');
  const [error, setError] = useState<string | null>(null);

  const handleShare = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    const result = await apiFetch(null, `internal/self_serve/rlhf/createChatDialogueShare`, {
      method: 'POST',
      body: {
        title: '',
        description: '',
        context,
        config,
        responses,
        taskId,
        projectId,
      },
    });
    setIsLoading(false);
    if (result.success) {
      const slug = result.shareId;
      setSlug(slug);
      setModalOpen(true);
    } else {
      setError('Unable to create share link');
    }
  }, [config, responses, context, taskId, projectId, setError, setSlug]);
  return {
    handleShare,
    isModalOpen: modalOpen,
    setModalOpen,
    isLoading,
    slug,
    error,
  };
};
